export default __webpack_public_path__ + "static/media/magic_korea.05604d50.png";